import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, handleReadTimeOffsetChange }) => {
  var _a;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { graphThrottleEnabled, readTimeOffset, timeoutGracePeriodMinutes } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandleReadTimeOffsetChange = (e) => {
    const { value } = e.target;
    if (value >= 0) {
      onChange(e);
      handleReadTimeOffsetChange("");
    } else {
      handleReadTimeOffsetChange(t("microsoftgraph.advanced.read_time_offset_negative_error"));
    }
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(ThrottlingCheckbox, { id: "graphThrottleEnabled", defaultChecked: graphThrottleEnabled == null ? void 0 : graphThrottleEnabled.value, onChange }),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "readTimeOffset",
        type: "number",
        value: readTimeOffset.value,
        min: "0",
        onChange: internalHandleReadTimeOffsetChange,
        required: true,
        help: t("microsoftgraph.advanced.read_time_offset_help"),
        label: t("microsoftgraph.advanced.read_time_offset")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "timeoutGracePeriodMinutes",
        type: "number",
        min: "1",
        value: (_a = timeoutGracePeriodMinutes == null ? void 0 : timeoutGracePeriodMinutes.value) != null ? _a : "",
        onChange,
        label: t("microsoftgraph.advanced.timeout_grace_period"),
        help: t("microsoftgraph.advanced.timeout_grace_period_help")
      }
    )
  );
};
export default FormAdvancedOptions;
